import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PrivateRoute from './components/PrivateRoute';
import AdminLayout from './components/layouts/AdminLayout';
import Users from './components/admin/Users';
import GeneraBuono from './components/admin/GeneraBuono';
import GeneraBuonoCrea from './components/admin/GeneraBuonoCrea';
import Archivio from './components/admin/Archivio';
import Impostazioni from './components/admin/Impostazioni';
import Statistiche from './components/admin/Statistiche';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          {/* Admin Only Routes */}
          <Route
            path="/admin/utenti"
            element={
              <PrivateRoute adminOnly>
                <Users />
              </PrivateRoute>
            }
          />
          {/* Routes accessible to all authenticated users */}
          <Route
            path="/admin/genera-buono"
            element={
              <PrivateRoute>
                <GeneraBuono />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/genera-buono/crea"
            element={
              <PrivateRoute>
                <GeneraBuonoCrea />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/archivio"
            element={
              <PrivateRoute>
                <Archivio />
              </PrivateRoute>
            }
          />
          {/* Admin Only Routes */}
          <Route
            path="/admin/impostazioni"
            element={
              <PrivateRoute adminOnly>
                <Impostazioni />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/statistiche"
            element={
              <PrivateRoute adminOnly>
                <Statistiche />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
